var map = {
	"./Messages.jpg": 348,
	"./Messages.png": 137,
	"./book.png": 138,
	"./box.png": 139,
	"./chat.png": 140,
	"./chat_01.png": 349,
	"./chat_02.png": 350,
	"./chat_icon.png": 351,
	"./cloud.png": 141,
	"./dashboard.png": 352,
	"./dot.png": 353,
	"./get_started_bg.png": 354,
	"./john.png": 142,
	"./left_leaf.png": 143,
	"./live_chat.png": 144,
	"./mobile.png": 145,
	"./panguin_img_one.png": 146,
	"./panguin_img_three.png": 147,
	"./panguin_img_two.png": 148,
	"./pluse.png": 149,
	"./richard.png": 150,
	"./right_leaf.png": 151,
	"./skyp_1.png": 355,
	"./skyp_2.png": 356,
	"./support_dashboard.jpg": 357,
	"./triangle.png": 152,
	"./video_icon.png": 358
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74;